/**
 * Format asset balance for display (trim trailing zeros, limit decimals).
 * @param {number|string} balance - Raw balance value
 * @param {string} symbol - Asset symbol (e.g. BTC, ETH)
 * @returns {string} Formatted balance string
 */
const assetFormatter = (balance, symbol = '') => {
  if (balance == null || balance === '') return '0';
  const num = Number(balance);
  if (Number.isNaN(num)) return String(balance);
  if (num === 0) return '0';
  const str = num.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 8,
  });
  return str.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
};

export default assetFormatter;
